import { AbstractControl } from '@angular/forms';
import { Guid, isEmptyString, isNil, Nillable } from '@web/utils';
import { WarehouseProductDataSourceService } from '../services/warehouse-product-data-source.service';
import { map, Observable, of, startWith, switchMap } from 'rxjs';
import { SelectItem } from '@web/shared/ui';

export const warehouseProductCurrentSelectItem = (options: {
  control: AbstractControl<Nillable<Guid>>;
  dataSource: WarehouseProductDataSourceService;
}): Observable<Nillable<SelectItem<Guid>>> => {
  const { control, dataSource } = options;

  return control.valueChanges.pipe(
    startWith(control.value),
    switchMap((id) => {
      if (!isNil(id) && !isEmptyString(id)) {
        return dataSource
          .fetchDetailsById('purebeauty', id)
          .pipe(map((item) => new SelectItem(item.name, item.id)));
      }

      return of(null);
    }),
  );
};
